import addEditShiftTemplate from '../../settings/AddEditShiftTemplate';

import templateUrl from './timeBlocksSidebarComponent.html';

class TimeBlocksSidebarCtrl {
  constructor(
    Authentication,
    AutomatedBreaksService,
    DayPartsService,
    TimeBlocksService,
    PersonaCollection,
    Restangular,
    Utils,
    $scope,
    $uibModal
  ) {
    'ngInject';

    Object.assign(this, {
      Authentication,
      AutomatedBreaksService,
      DayPartsService,
      TimeBlocksService,
      PersonaCollection,
      Restangular,
      Utils,
      $scope,
      $uibModal,
    });
  }

  $onInit() {
    this.userOrgSettings = { ...this.Authentication.user.orgSettings };
    this.activeTab = 'timeBlocks';
    this.areAutomatedBreaksOn = this.AutomatedBreaksService.areAutomatedBreaksOn;

    this.$scope.$watch('ctrl.open', () => {
      if (this.open) {
        this.loadDayParts();
      }
    });
  }

  async loadDayParts() {
    this.dayPartsLoading = true;
    try {
      await this.DayPartsService.loadData();
    } finally {
      this.dayPartsLoading = false;
    }
  }

  timeBlocksClicked() {
    this.activeTab = 'timeBlocks';
  }

  dayPartsClicked() {
    this.activeTab = 'dayParts';
  }

  close() {
    this.open = false;
  }

  get timeBlocks() {
    return this.TimeBlocksService.timeBlocks;
  }

  get dayParts() {
    return this.DayPartsService.dayParts;
  }

  async editTimeBlock(timeBlock) {
    const updatedTimeBlock = await addEditShiftTemplate(this.$uibModal, { ...timeBlock });
    this.TimeBlocksService.editTimeBlock(timeBlock, updatedTimeBlock);
  }

  async addTimeBlock() {
    const { start, end } = this.Utils.getDefaultStartEnd(
      '2016-01-01',
      undefined,
      this.Authentication.user.orgSettings
    );
    const newTemplate = {
      dtstart: start,
      dtend: end,
      locations: [],
    };

    const me = this.PersonaCollection.me;
    if (me.locations.length === 1) {
      newTemplate.locations.push(me.locations[0]);
    }

    if (this.Authentication.user.orgSettings.shiftBreakDefaultDuration) {
      newTemplate.breakDuration = this.Authentication.user.orgSettings.shiftBreakDefaultDuration;
    }

    const shiftTemplate = await addEditShiftTemplate(this.$uibModal, newTemplate);
    this.TimeBlocksService.addTimeBlock(shiftTemplate);
  }

  addEditDayPart(dayPart = {}) {
    return this.$uibModal.open({
      size: '620',
      controller: function addEditDayPartCtrl() {
        this.dayPart = dayPart;
      },
      controllerAs: 'ctrl',
      template:
        '<edit-day-part dismiss="$dismiss()" day-part="ctrl.dayPart" on-submit="$close(dayPart)"></edit-day-part>',
    }).result;
  }

  async addDayPart() {
    const dayPart = await this.addEditDayPart();
    await this.DayPartsService.addDayPart(dayPart);
  }

  async editDayPart(dayPart) {
    const updatedDayPart = await this.addEditDayPart({ ...dayPart });
    await this.DayPartsService.editDayPart(dayPart, updatedDayPart);
  }
}

export default {
  templateUrl,
  controller: TimeBlocksSidebarCtrl,
  controllerAs: 'ctrl',
  bindings: {
    open: '=',
  },
};
